import { z } from 'zod';
/** Statut d'un job — `03` §2 (`jobs.status`). */
export const JOB_STATUSES = ['pending', 'running', 'done', 'failed', 'cancelled'];
export const jobStatusSchema = z.enum(JOB_STATUSES);
export const JOB_STATUS = {
    pending: { code: 'pending', label: 'En attente', tone: 'gray' },
    running: { code: 'running', label: 'En cours', tone: 'blue' },
    done: { code: 'done', label: 'Terminé', tone: 'green' },
    failed: { code: 'failed', label: 'Échec', tone: 'red' },
    cancelled: { code: 'cancelled', label: 'Annulé', tone: 'gray' },
};
/** Types de job — `03` §2 (`jobs.type`) et `04` §3. */
export const JOB_TYPES = [
    'ingest-order',
    'prepare-order',
    'send-file',
    'poll-orders',
    'fulfillment-run',
    'pennylane-run',
    'prepare-invoice',
    'flush-queue',
    'send-alert',
    'health-check',
    'catchup',
    'preview-order',
    'cleanup',
    'recharge-webhook',
    'recharge-export',
    'recharge-canton-scan',
    'recharge-discount-run',
    'recharge-discount-reconcile',
    'klaviyo-sync',
];
export const jobTypeSchema = z.enum(JOB_TYPES);
export const JOB_TYPE = {
    'ingest-order': { code: 'ingest-order', label: 'Réception d’une commande', tone: 'blue' },
    'prepare-order': { code: 'prepare-order', label: 'Préparation d’une commande', tone: 'blue' },
    'send-file': { code: 'send-file', label: 'Envoi d’un fichier', tone: 'blue' },
    'poll-orders': { code: 'poll-orders', label: 'Polling de sécurité', tone: 'gray' },
    'fulfillment-run': { code: 'fulfillment-run', label: 'Run expéditions', tone: 'blue' },
    'pennylane-run': { code: 'pennylane-run', label: 'Run Pennylane', tone: 'blue' },
    'prepare-invoice': { code: 'prepare-invoice', label: 'Préparation d’une facture', tone: 'blue' },
    'flush-queue': { code: 'flush-queue', label: 'Envoi de la file d’attente', tone: 'blue' },
    'send-alert': { code: 'send-alert', label: 'Envoi d’une alerte', tone: 'gray' },
    'health-check': { code: 'health-check', label: 'Contrôle des connexions', tone: 'gray' },
    catchup: { code: 'catchup', label: 'Rattrapage', tone: 'blue' },
    'preview-order': { code: 'preview-order', label: 'Aperçu d’une commande', tone: 'gray' },
    cleanup: { code: 'cleanup', label: 'Nettoyage', tone: 'gray' },
    'recharge-webhook': { code: 'recharge-webhook', label: 'Traitement d’un webhook Recharge', tone: 'blue' },
    'recharge-export': { code: 'recharge-export', label: 'Export des abonnements actifs', tone: 'blue' },
    'recharge-canton-scan': { code: 'recharge-canton-scan', label: 'Vérification des cantons suisses', tone: 'blue' },
    'recharge-discount-run': { code: 'recharge-discount-run', label: 'Remise renouvellement', tone: 'blue' },
    'recharge-discount-reconcile': { code: 'recharge-discount-reconcile', label: 'Réconciliation des remises renouvellement', tone: 'gray' },
    'klaviyo-sync': { code: 'klaviyo-sync', label: 'Synchronisation Klaviyo des abonnés', tone: 'blue' },
};
/**
 * Groupes de concurrence — `04` §3.1. Les uploads vers un même compte FTP
 * Martelet ne doivent jamais être parallélisés. Tous les jobs qui appellent
 * l'API Recharge (≈ 1 requête/s) passent par un groupe dédié limité à 1, pour
 * ne jamais consommer les slots des flux Martelet (`06` §1.1).
 */
export const CONCURRENCY_GROUPS = {
    ftp215: 'ftp:215',
    ftp216: 'ftp:216',
    rechargeApi: 'recharge:api',
    /** Synchronisation Klaviyo (`06` §11) : une seule à la fois, sans bloquer les webhooks Recharge. */
    klaviyoApi: 'klaviyo:api',
};
//# sourceMappingURL=job.js.map